import { ErrorBoundary } from 'react-error-boundary';

import { ChatErrorMessage } from '#components/chat/messages/ChatErrorMessage';

export interface ChatErrorBoundaryProps {
  message?: React.ReactNode;
}

export function ChatErrorBoundary({
  children,
  message = 'An error occurred while displaying this message.',
}: React.PropsWithChildren<ChatErrorBoundaryProps>) {
  return <ErrorBoundary fallback={<ChatErrorMessage>{message}</ChatErrorMessage>}>{children}</ErrorBoundary>;
}
